<svelte:options tag={null} />
<script>
  import { get_current_component } from "svelte/internal";
  import "@everymatrix/em-accordion";

  export let success = true;
  export let error;
  let validationError;

  let limits = [
    {
      period: "Daily",
      minutes: 0,
      checked: false
    },
    {
      period: "Weekly",
      minutes: 0,
      checked: false
    },
    {
      period: "Monthly",
      minutes: 0,
      checked: false
    }
  ];

  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleData = (list) => {
    let data = [];
    validationError = null;

    let sorted = list.filter(item => item.checked);
    
    if (sorted.length === 0) {
      validationError = "Must have atleast a period checked";
      return;
    }
    // Process Data
    for (let obj of sorted) {
      if(obj.minutes < 60) {
        validationError = "Minutes should be great than or equal to 60";
        return;
      } else {
        // Remove Checked Prop
        obj.hasOwnProperty('checked') ? delete obj.checked : null;
        // Push Sanitized Object
        data.push(obj);
      }
    }

    if(data.length > 0) {
      // Reset Selections
      // NOTE: This does not work as it should
      limits = [
        {
          period: "Daily",
          minutes: 0,
          checked: false
        },
        {
          period: "Weekly",
          minutes: 0,
          checked: false
        },
        {
          period: "Monthly",
          minutes: 0,
          checked: false
        }
      ];
      // Send Custom Event
      dispatchWcEvent("change", { "cumulativeSessionLimits": data });
    }
  };  
</script>


<div class="accordion">
  <em-accordion>
    <!-- Title -->
    <h3 slot="title" class="accordion__title">
      Cumulative Session Limits
    </h3>
    <!-- Content -->
    <div slot="content" class="accordion__content">
      {#each limits as limit}
        <!-- Limit Name -->
        <label class="selectWrapper">
          <input
            class="checkbox"
            type=checkbox
            bind:checked={limit.checked}
            value="{limit.period}"
          >
          <span>
            {limit.period}
          </span>
        </label>
        <!-- Limit Input -->
        {#if limit.checked}
          <label class="inputWrapper">
            <input
              class="input"
              type="number" 
              name="depositAmount"
              bind:value="{limit.minutes}"
            >
            <span>minutes</span>
          </label>
        {/if}
      {/each}
      {#if validationError}
        <p style="color: red;">
          {validationError}
        </p>
      {/if}
      {#if success?.hasOwnProperty('cumulativeSessionLimit')}
        <p style="color: green;">
          Limit saved succesfully
        </p>
      {/if}
      {#if error && error.includes('CumulativeLimit')}
        <p style="color: red;">
          {error.slice(0, 26)}
        </p>
      {/if}
      <!-- Save Button -->
    <button
      class="button" 
      on:click={() => handleData(limits)}
    >
      Save
    </button>
    </div>
  </em-accordion>
</div>


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }
  .accordion {
    margin-bottom: 10px;

    &__content {
      display: flex;
      flex-direction: column;
    }
  }

  .selectWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    cursor: pointer;
    &:last-child { margin-bottom: 0; }
    span { 
      margin-left: 10px;
      font-size: 12px;
    }
  }

  .inputWrapper {
    margin-bottom: 10px;
    span { font-weight: bold; }
  }

  .input {
    max-width: 50%;
    padding: 5px 10px;
    margin-right: 10px;
  }

  .button {
    display: block;
    width: 150px;
    margin: 20px auto 0 auto;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }
</style>
